import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme, Stack, Typography } from '@mui/material';
import { SortDirection, SortBy } from '../../types/domainTypes';
import { SortDirectionIcon } from '../SortDirectionIcon/SortDirectionIcon';
import { MenuButton } from 'components/MenuButton/MenuButton';

type Props = {
  options: string[];
  sortBy: SortBy;
  sortDirection: SortDirection;
  handleSetSortBy: (value: SortBy) => void;
  handleSetSortDirection: () => void;
};

export function SelectSortDropdown({ options, sortBy, sortDirection, handleSetSortBy, handleSetSortDirection }: Props): ReactElement {
  const { t } = useTranslation();
  const theme = useTheme();

  const getOptionText = (option: string): string => {
    switch (option) {
      case SortBy.LastModified:
        return t('projects-page.sort-by-label-last-modified');
      case SortBy.DateCreated:
        return t('projects-page.sort-by-label-date-created');
      case SortBy.ProjectName:
        return t('projects-page.sort-by-label-project-name');
      case SortBy.EngineerName:
        return t('projects-page.sort-by-label-engineer-name');
      default:
        return '';
    }
  };

  const menuButtonOptions = options.reduce(
    (acc: { value: string; text: string }[], value) => [...acc, { value, text: getOptionText(value) }],
    []
  );

  return (
    <Stack direction="row" marginLeft="-24px">
      <MenuButton
        buttonText={
          <Typography color={theme.palette.text.primary} letterSpacing="0" textTransform="initial">
            {getOptionText(sortBy)}
          </Typography>
        }
        showIcon={false}
        options={menuButtonOptions}
        onMenuItemClicked={(value) => handleSetSortBy(value as SortBy)}
      />
      <SortDirectionIcon sortDirection={sortDirection} onSetSortDirection={handleSetSortDirection} />
    </Stack>
  );
}
